@for (row of rows; track row; let i = $index) {
  <div
    class="spa-list-row-container"
    data-testid="guest_including_companions"
    [class.spa-list-row-border]="showBorder() && i < (rows?.length ?? 0) - 1"
  >
    <div class="spa-list-row outer" data-testid="main_guest" [class.spa-list-age-issue]="rowContainsError(row[rowId])">
      <div
        class="spa-list-row"
        (click)="onClickRow(row)"
        [ngClass]="{
          'spa-list-selected-row': row[rowId] === selectedRow,
          'spa-list-hint': rowContainsHint(row[rowId]),
          'spa-list-interactive': interactive,
        }"
        id="list-row-{{ i }}"
        data-testid="selected_person"
      >
        <chd-icon-button
          data-testid="remove_selected_person_button"
          iconSrc="assets/icon/close.svg"
          id="list-row-delete-btn-{{ i }}"
          variant="text"
          [ariaLabel]="'label.button.close' | transloco"
          (clicked)="removeSelectedEmployee(i)"
        />
        @for (column of positionedList.left; track column; let j = $index) {
          <div class="spa-list-element-container" [ngClass]="[column.size ?? '']" [attr.data-testid]="column.key">
            @if (getTemplate(column.key); as tmp) {
              <ng-container *ngTemplateOutlet="tmp.template; context: { row }"></ng-container>
            } @else {
              <chd-text-input
                id="{{ column.key }}-{{ i }}"
                readonly
                [attr.data-testid]="column.key"
                [label]="(translationKey(column) | transloco) || ''"
                [ngClass]="[column.size ?? '']"
                [optionalLabel]="''"
                [value]="cellValue(row, column)"
              />
            }
          </div>
        }
      </div>

      @for (column of positionedList.right; track column; let j = $index) {
        <div class="spa-list-element-container" id="{{ column.key }}-{{ i }}" [ngClass]="[column.size ?? '']">
          @if (getTemplate(column.key); as tmp) {
            <ng-container *ngTemplateOutlet="tmp.template; context: { row }"></ng-container>
            <div class="spa-list-newprice-tag" id="newprice-{{ i }}"></div>
          } @else {
            <chd-text-input
              id="{{ column.key }}-{{ i }}"
              readonly
              [label]="(translationKey(column) | transloco) || ''"
              [optionalLabel]="''"
              [ngClass]="[column.size ?? '']"
              [value]="cellValue(row, column)"
            />
          }
        </div>
      }
    </div>

    <!-- Age Restriction -->
    @if (rowContainsError(row[rowId])) {
      <chd-error-message>{{ errorText() }}</chd-error-message>
    }

    <!-- Overlapping Bookings -->
    <div
      class="spa-list-bottom-space-and-hint-text"
      [title]="rowContainsHint(row[rowId]) ? hintText : ''"
      data-testid="overlapping_booking_hint"
    >
      {{ rowContainsHint(row[rowId]) ? hintText : "" }}
    </div>

    @for (column of positionedList.bottom; track column.key) {
      <div class="spa-list-bottom-container" id="{{ column.key }}-{{ i }}" [ngClass]="[column.size ?? '']">
        @if (getTemplate(column.key); as tmp) {
          <ng-container *ngTemplateOutlet="tmp.template; context: { row }"></ng-container>
          <div class="spa-list-newprice-tag" id="newprice-{{ i }}"></div>
        } @else {
          <chd-text-input
            id="{{ column.key }}-{{ i }}"
            readonly
            [label]="(translationKey(column) | transloco) || ''"
            [ngClass]="[column.size ?? '']"
            [value]="cellValue(row, column)"
          />
        }
      </div>
    }
  </div>
}
